package one.healthium.uscreen.ui.util

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import one.healthium.ui.compose.theme.AppTheme

fun parseHexColor(value: String): Color? {
    val hex = value.removePrefix("#")
    val longValue = hex.toLongOrNull(16) ?: return null
    return when (hex.length) {
        6 -> Color(longValue or 0xFF000000)
        8 -> Color(longValue)
        else -> null
    }
}

@Composable
fun resolveNamedColor(value: String): Color? {
    return when (value) {
        "primary" -> AppTheme.colors.primary
        "textSecondary" -> AppTheme.colors.text300
        "white" -> Color.White
        "black" -> Color.Black
        else -> parseHexColor(value)
    }
}
